import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { BaseService } from '../services/base.service';

/**
 * Пропускає лише користувачів з is_admin.
 * Профіль завантажується в ProfileGuard на батьківському роуті /crm,
 * тому тут user вже доступний.
 */
@Injectable()
export class AdminGuard {
  constructor(
    private router: Router,
    private baseService: BaseService,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.baseService.user?.is_admin) {
      return true;
    }

    return this.router.createUrlTree(['/crm/dashboard']);
  }
}
